import React from 'react';
import { motion } from 'framer-motion';
import { Send, Globe, MapPin, ExternalLink } from 'lucide-react';
const friendLinks = [{
  name: 'TTVIP-64',
  url: 'https://ttvip-64.com/'
}, {
  name: 'Shiok27',
  url: 'https://shiok27.com/'
}, {
  name: 'XFY01',
  url: 'https://xfy01.net/'
}, {
  name: 'SGHarem6',
  url: 'https://sgharem6.net/'
}, {
  name: 'QC52',
  url: 'https://qc52.me/'
}, {
  name: 'SGLonelyGuy',
  url: 'https://sglonelyguy.me'
}, {
  name: 'TTVIP',
  url: 'https://ttvip.life'
}, {
  name: 'Locanto',
  url: 'https://locanto.space'
}, {
  name: 'KKBaby',
  url: 'https://kkbaby.site'
}, {
  name: 'XFY8',
  url: 'https://xfy8.com'
}, {
  name: 'SGBeautyCastle',
  url: 'https://sgbeautycastle.live'
}, {
  name: 'Shiok26',
  url: 'https://shiok26.site'
}, {
  name: 'SGHarem',
  url: 'https://sgharem.site'
}, {
  name: 'Shiok8',
  url: 'https://shiok8.xyz'
}, {
  name: 'Geylang777',
  url: 'https://geylang777.info'
}, {
  name: 'TTVIP-62',
  url: 'https://ttvip-62.site'
}, {
  name: 'Geylang666',
  url: 'https://geylang666.me'
}, {
  name: 'IsYou',
  url: 'https://isyou.net'
}];
export function ContactCTA() {
  return <section id="contact" className="py-24 md:py-32 relative overflow-hidden" data-id="element-28">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-bg to-dark-surface z-0" data-id="element-29" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-31">
          <h2 className="text-4xl md:text-6xl font-serif text-gold-100 mb-6" data-id="element-32">
            开启尊享之旅
          </h2>
          <p className="text-xl md:text-2xl text-gold-300 font-serif italic mb-10" data-id="element-33">
            Begin Your Journey
          </p>

          <p className="text-gold-100/70 max-w-xl mx-auto mb-16 leading-relaxed" data-id="element-34">
            Discretion and professionalism are our hallmarks. Contact us today
            to arrange your exclusive experience. We are available 24/7 to
            assist with your reservation.
          </p>
        </motion.div>

        {/* Visit Website Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mb-16" data-id="element-35">
          <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-gold-400 text-dark-bg px-10 py-5 text-lg font-bold tracking-wide rounded-sm hover:bg-gold-300 transition-all duration-300 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)] transform hover:-translate-y-1" data-id="element-36">
            <Globe className="w-5 h-5" data-id="element-37" />
            <span data-id="element-38">访问官网 · Visit Website</span>
          </a>
        </motion.div>

        {/* Friend Links */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-8 pt-8 border-t border-gold-400/10" data-id="element-39">
          <p className="text-gold-400/60 text-xs uppercase tracking-widest mb-4" data-id="element-40">
            友情链接 · Partner Sites
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-41">
            {friendLinks.map(link => <a key={link.name} href={link.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-gold-100/50 hover:text-gold-400 text-sm transition-colors duration-300" data-id="element-42">
                <ExternalLink className="w-3 h-3" data-id="element-43" />
                <span data-id="element-44">{link.name}</span>
              </a>)}
          </div>
        </motion.div>

        {/* Footer Info */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-8 pt-8 border-t border-gold-400/10 flex flex-col md:flex-row items-center justify-between text-gold-800 text-sm" data-id="element-45">
          <div className="flex items-center mb-4 md:mb-0" data-id="element-46">
            <MapPin className="w-4 h-4 mr-2" data-id="element-47" />
            <span data-id="element-48">Singapore · Premium Service</span>
          </div>
          <p data-id="element-49">TTvip © 2015-2025. All Rights Reserved.</p>
        </motion.div>
      </div>
    </section>;
}